export const TOUR_STEPS_CONFIG = [
    {
        element: '#tour-logo',
        page: 'dashboard',
        popover: {
            title: 'Welcome',
            description: 'Get started with a quick overview of your workspace. Access key tools and features from one place.',
            side: "bottom",
            align: 'start',
            showButtons: ['next'],
            popoverClass: 'tour-modern-popover first-step'
        }
    },

    {
        element: '#tour-protection-plans',
        page: 'dashboard',
        popover: {
            title: 'Explore Plans',
            description: 'Explore available protection plans offered to customers. Each plan includes coverage details and pricing options.',
            side: "bottom",
            align: 'center'
        }
    },
    {
        element: '#tour-review-coverage',
        page: 'products',
        popover: {
            title: 'Review Coverage',
            description: 'Review coverage limits and benefits for the selected plan. Ensure the protection matches customer needs before proceeding.',
            side: "top",
            align: 'center'
        }
    },
    {
        element: '#tour-select-plan',
        page: 'products',
        popover: {
            title: 'Select Your Plan',
            description: 'Choose the most suitable protection plan. Confirm plan details before moving to checkout.',
            side: "top",
            align: 'center'
        },
        action: 'select_plan'
    },
    {
        element: '#tour-continue-checkout',
        page: 'products',
        popover: {
            title: 'Complete Purchase',
            description: 'Complete the purchase securely and efficiently. Review final details and confirm the transaction.',
            side: "top",
            align: 'center'
        }
    },
    {
        element: '#tour-affiliates',
        page: 'dashboard',
        popover: {
            title: 'Affiliate Dashboard',
            description: 'Get a snapshot of your affiliate activity. Track performance, earnings, and key metrics at a glance.',
            side: "top",
            align: 'center'
        }
    },
    {
        element: '#tour-add-affiliate',
        page: 'affiliates',
        popover: {
            title: 'Add New Affiliate',
            description: 'Add a new affiliate to the system. Enter required details and activate the affiliate account.',
            side: "bottom",
            align: 'center'
        },
    },
    {
        element: '#tour-save-affiliate',
        page: 'affiliates',
        popover: {
            title: 'Save Affiliate',
            description: 'Fill in the details and click save to create the affiliate.',
            side: "top",
            align: 'center'
        },
        action: 'save_affiliate'
    },
    {
        element: '#tour-sales-history',
        page: 'dashboard',
        popover: {
            title: 'Sales History',
            description: 'Monitor all sales generated through the platform. View transaction details and performance trends.',
            side: "top",
            align: 'center'
        }
    },
    {
        element: '#tour-commission',
        page: 'dashboard',
        popover: {
            title: 'Commission Dashboard',
            description: 'Track commissions earned from completed sales. Review payouts and commission breakdowns.',
            side: "top",
            align: 'center'
        }
    },
    {
        element: '#tour-profile-pic',
        page: 'dashboard',
        popover: {
            title: 'My Profile',
            description: 'Manage your personal and account information. Update details to keep your profile up to date.',
            side: "bottom",
            align: 'end'
        }
    },
    {
        element: '#tour-copy-url',
        page: 'dashboard',
        popover: {
            title: 'Copy Referral Link',
            description: 'Copy your unique referral link instantly. Share it to start earning through referrals.',
            side: "left",
            align: 'center'
        },
        action: 'open_profile'
    },
    {
        page: 'dashboard',
        popover: {
            title: 'Tour Completed',
            description: 'That’s it! You’ve completed the quick tour. Thank you for taking the time to explore the platform.',
            side: "bottom",
            align: 'center',
            nextBtnText: 'Done',
            showButtons: ['next'],
            popoverClass: 'tour-modern-popover last-step'
        }
    },



];
